import { IPatient } from '../interfaces'
import useColumnService from '../logic/useColumnPatient'
import useModalReceive from '../logic/useModalReceive'
import useSearchPatient from '../logic/useSearchPatient'
import { Col, Form, Row } from 'antd'
import { Button, Search } from 'components/atoms'
import { useModal } from 'hooks'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { StyledTable } from 'styles/styledGlobal'

const StyledTablePatient = styled(StyledTable)`
  min-height: 250px;
`

const StyledColAdd = styled(Col)`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`

const FindProfileModal = ({ phoneNumber }: { phoneNumber: string }) => {
  const [form] = Form.useForm()
  const { loading, patients, handleOnSearch } = useSearchPatient()
  const { columns } = useColumnService(onAction)
  const modal = useModal()
  const { handleAddNewBooking } = useModalReceive()
  const [searchValue, setSearchValue] = useState<string>(phoneNumber)

  useEffect(() => {
    if (phoneNumber) {
      handleOnSearch(phoneNumber)
    }
  }, [phoneNumber])

  function onAction(patient: IPatient) {
    handleAddNewBooking(patient)
  }

  return (
    <Form form={form} style={{ width: '100%' }}>
      <Row gutter={16}>
        <Col span={24} style={{ marginBottom: 12 }}>
          <Search
            onSearch={handleOnSearch}
            onChange={setSearchValue}
            value={searchValue}
            placeholder="input-phone-number-search"
          />
        </Col>

        <Col span={24}>
          <StyledTablePatient
            sticky
            columns={columns as any}
            dataSource={patients}
            pagination={false}
            rowKey="phone_number"
            loading={loading}
          />
        </Col>
        <StyledColAdd span={24}>
          <Button
            color="green"
            icon={<img src="/images/ic-add.svg" alt="" />}
            onClick={() => modal.close({ isAddNew: true })}>
            {t('add-new-profile')}
          </Button>
        </StyledColAdd>
      </Row>
    </Form>
  )
}

export default FindProfileModal
